import React from "react";
import PropTypes from "prop-types";

import includes from "lodash/includes";

import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";

import theme from "../../../../components/Theme";
import { de, arvr, meta, mulesoft, nginx, salesforce, sfds, sfdev, dpl } from "../../../../components/Theme/palette";
import { useMemo } from "react";
import { RTL_LANGUAGES } from "../../../../constants";
import getSelectedLocale from "../../../../state/selectors/i18n";
import { connect } from "react-redux";

/**
 * Define hard coded values for css.
 * Will be deleted once all question types migrated to material-ui
 */
const Theme = ({ slug, children, locale }) => {
  const palette = 
    includes(slug, "arvr") ? arvr
  : includes(slug, "dn") ? de
  : includes(slug, "mics") ? meta
  : includes(slug, "mu_") ? mulesoft
  : includes(slug, "nis") ? nginx
  : includes(slug, "sf_") ? salesforce
  : includes(slug, "sfds") ? sfds
  : includes(slug, "sfdev") ? sfdev
  : includes(slug, "dpl") ? dpl
  : de;

  const isRtl = useMemo(() => {
    return RTL_LANGUAGES.includes(locale);
  }, [locale]);

  return (
    <MuiThemeProvider
      theme={createTheme({
        ...theme,
        palette,
        direction: isRtl ? "rtl" : "ltr",
      })}
    >
      <div
        style={{
          "--text-color": "#2b2d42",
          "--color-error": "#e40000",
          "--color-text-gray": "#b0c0da",
          height: "100%",
          "lineHeight": "normal"
        }}
      >
        {children}
      </div>
    </MuiThemeProvider>
  );
};

Theme.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element]))
  ]).isRequired,
  slug: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  locale: getSelectedLocale(state),
});

export default connect(mapStateToProps)(Theme);
